import { INTEGRATIONS } from '../data/mock';
import { useState } from 'react';

const CATEGORIES = ['All', 'E-Commerce', 'Payments', 'Automation', 'Marketing', 'Forms', 'SMS', 'AI'];

export default function IntegrationsGrid() {
  const [cat, setCat] = useState('All');
  const items = cat === 'All' ? INTEGRATIONS : INTEGRATIONS.filter((i) => i.cat === cat);

  return (
    <section className="section bg-slate-50/60">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="chip mb-4">ACTIWA Integrations</p>
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900">
            Connect with 35+ Apps
          </h2>
          <p className="mt-4 text-slate-600">
            Seamlessly integrate with your favorite tools and platforms.
          </p>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              className={`px-4 py-2 text-sm font-medium rounded-full border transition-colors ${
                cat === c
                  ? 'bg-slate-900 text-white border-slate-900'
                  : 'bg-white text-slate-700 border-slate-200 hover:border-emerald-400'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {items.map((it) => (
            <div
              key={it.name}
              className="bg-white border border-slate-200 rounded-2xl p-5 text-center card-lift"
            >
              <div className="mx-auto w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-100 to-white border border-emerald-100 grid place-items-center text-emerald-700 font-extrabold text-lg">
                {it.name[0]}
              </div>
              <p className="mt-3 text-sm font-semibold text-slate-900">{it.name}</p>
              <p className="text-[11px] text-slate-500 mt-0.5">{it.cat}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
